module.exports = __webpack_public_path__ + "img/solution_communitycare_sys_de.857163cc.jpg";